import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Tabs } from '../common';
import { NavPageWrapper } from "../common/Nav";
import ActiveContests from './ActiveContests';

export class ContestLeaderboard extends Component {
  state = {
    contestEventAgents: [],
    isLoading: true
  }

  componentDidMount = () => {
    const { 
      actions: { fetchActiveContestEventAgents, setSignalRConnectionContestAction },
      User: { userID }
    } = this.props;
    
    fetchActiveContestEventAgents(userID);
    setSignalRConnectionContestAction();
  }

  componentWillUnmount = () => {
    // when user leaves leaderboards page, reset contestEventResults & contestEventAgents
    // ensures no stale data will remain in redux
    this.props.actions.resetContestData()
  }


  componentDidUpdate = (prevProps) => {
    const { contests: { contestEventAgents } } = this.props;
    if(contestEventAgents && prevProps.contests.contestEventAgents !== contestEventAgents) {
      this.setState({ contestEventAgents, isLoading: false })
    }
  }

  render() {
    const {
      props: { match: { path } },
      state: { contestEventAgents, isLoading }
    } = this;

    return (
      <NavPageWrapper currPath={ path }>
        <div className="ContestLeaderboard">
          <div className="ContestLeaderboard__title-wrap">
            <div className="ContestLeaderboard__title">
              All Contests
            </div>
          </div>
          <Tabs activeTab={'Active Contests'} isEdit={true}>
            <div label={ 'Active Contests' }>
              { !isLoading ?
              <div className="ActiveContests">
                { contestEventAgents.length > 0 ?
                  contestEventAgents.map(ele => {
                    return (
                      <ActiveContests 
                        contestEventId={ele.contestEventId}
                        contestName={ ele.contestName }
                        contestQualifier={ ele.qualifierThreshold }
                        contestEndTime={ ele.endDate }
                        contestQualifierType={ ele.qualifierType }
                        key={ 'ActiveContest-' + ele.contestEventId }
                      />
                    )
                  })
                  :
                  <div className="ActiveContests__unavailable">No active contests available.</div>
                }
              </div>
              :
              <div className='ActiveContests-loader'>
                <div className='ActiveContests-loader__overlay'>
                  <div className='ActiveContests-loader__wrap'>
                    <div className='ActiveContests-loader__bars'>
                      <span></span><span></span><span></span><span></span><span></span>
                    </div>
                    <h6 className='ActiveContests-loader__text'>Loading...</h6>
                  </div>
                </div>
              </div>
              }
            </div>
          </Tabs>
        </div>
      </NavPageWrapper>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = ({
  common: { user: User},
  contests
}) => {
  return {
    User,
    contests
  };
}

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators({ ...actions }, dispatch)});

export default connect(mapStateToProps, mapDispatchToProps)(ContestLeaderboard);



// WEBPACK FOOTER //
// ./src/features/contests/ContestLeaderboard.js